module.exports = __webpack_public_path__ + "static/media/bg-cad.b37dc7ce.jpg";